export default __webpack_public_path__ + "static/media/tik-3.2c1d9906.svg";